
<table v-if="candidate" class="ui definition keyValueTable table">
  <tr v-if="candidate.operator_name">
    <td>担当者名</td>
    <td>{{ candidate.operator_name }}</td>
  </tr>
  <tr>
    <td>お客様向け立候補コメント</td>
    <td>
      <div class="linebreak">{{ candidate.message }}</div>
    </td>
  </tr>
  <tr v-if="planDetail">
    <td>コース内容</td>
    <td>
      <div class="linebreak">{{ planDetail }}</div>
    </td>
  </tr>
  <tr v-if="candidate.price">
    <td>価格(税込)</td>
    <td><span v-if="candidate.price">{{ candidate.price | formatCurrency }}円</span></td>
  </tr>
  <tr v-if="candidate.dish_count">
    <td>品数</td>
    <td><span v-if="candidate.dish_count">{{ candidate.dish_count }}品</span></td>
  </tr>
  <!--tr>
    <td>コンシェルジュへのメッセージ</td>
    <td>
      <div class="linebreak">{{ candidate.message_for_concierge }}</div>
    </td>
  </tr-->
</table>
